import {get} from '@/services/http';
import {Row} from '@/components/ui/table/table.model';
import {StatsParams, Threshold} from '@/model/stats/stats.model';

const BASE_URL = import.meta.env.VUE_APP_API_ROOT;

export type StatsResult = {
	rows: Row[];
	/** the minimum a row had to reach, null if every row is ranked */
	threshold: Threshold | null;
};

// only the top queries answer {threshold, rows}, every other query a plain array
type StatsAnswer = Row[] | StatsResult;

export function toResult(answer: StatsAnswer): StatsResult {
	return Array.isArray(answer) ? {rows: answer, threshold: null} : answer;
}

export const STATS_SERVICE = {
	stats: function (params: StatsParams): Promise<StatsResult> {
		return get<StatsAnswer>(
			BASE_URL + `/${params.resource}/${params.query}`, {
				params: {
					season: params.season,
					league: params.league,
					gameType: params.gameType,
					orderBy: params.orderBy,
					count: params.limitRows,
					ha: params.ha,
					team: params.team,
					playerId: params.playerId
				}
			}).then(response => toResult(response.data));
	}
};
